import { css } from 'lit';
export default css`:host{display:block}:host([hidden]){display:none}.non-prod-banner{padding:var(--space-200);background-color:var(--color-warning);color:var(--color-neutral-white);font-weight:var(--font-weight-bold);text-align:center}.non-prod-banner__content{margin:0}.non-prod-banner__link{color:var(--color-neutral-white);font-weight:var(--font-weight-bold)}
`;
